<script setup>
import { onMounted, ref } from 'vue';
import { slider } from '@phx-styleguides/iwc';
import { PhxsgIcon } from '@sg/src/View/Components/Atoms/Icon';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

defineProps({
  id: {
    type: String,
    required: true,
  },
  ariaLabel: {
    type: String,
    default: '',
  },
});

const sliderRef = ref(null);
const sliderInstance = ref(null);

onMounted(() => {
  if (sliderRef.value) {
    sliderInstance.value = slider(sliderRef.value, {
      threshold: 5,
      slidesPerView: 'auto',
      mousewheel: {
        forceToAxis: true,
      },
    });
  }
});
</script>

<template>
  <div
    :id="id"
    ref="sliderRef"
    class="slider slider--cards slider--nav-above slider–nav-end"
    role="group"
    aria-roledescription="carousel"
    :aria-label="ariaLabel"
  >
    <div class="slider__nav slider__nav--prev">
      <PhxsgButton icon-only size="sm">
        <template #content>
          <PhxsgIcon id="triangle-left" size="md" bidirectional />
        </template>
      </PhxsgButton>
    </div>

    <div class="slider__body" aria-atomic="false" aria-live="polite">
      <slot name="body" />
    </div>

    <div class="slider__nav slider__nav--next">
      <PhxsgButton icon-only size="sm">
        <template #content>
          <PhxsgIcon id="triangle-right" size="md" bidirectional />
        </template>
      </PhxsgButton>
    </div>

    <div class="slider__footer">
      <div class="slider__pagination" role="tablist" aria-label="Choose slide to display"></div>
    </div>
  </div>
</template>
